// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"49":"d1769046","144":"21f7881c","217":"6e77e05b","256":"79014fcd","543":"e48bb04f","940":"65745d44"}[chunkId] + ".js";
};